import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import Tooltip from '../../../Tooltip';
import styles from './StatusIcon.module.css';

const bindClasses = classNameBind.bind(styles);

const STATUS_TYPE = {
  greenFilled: 'green-filled',
  greenHollow: 'green-hollow',
  redFilled: 'red-filled',
  redHollow: 'red-hollow',
  blackFilled: 'black-filled',
  blackHollow: 'black-hollow',
  yellowFilled: 'yellow-filled',
  yellowHollow: 'yellow-hollow',
  grayHollow: 'gray-hollow',
  grayFilled: 'gray-filled',
  paused: 'paused',
};

const StatusIcon = ({
  status,
} = {}) => {
  const iconName = React.useMemo(() => {
    if (status.type === 'paused') return 'pause';

    return status.type.indexOf('-hollow') > 0 ? 'status-hollow' : 'status';
  }, [status.type]);

  const iconColor = React.useMemo(() => {
    switch (status.type) {
      case STATUS_TYPE.greenHollow:
      case STATUS_TYPE.greenFilled:
        return 'green';
      case STATUS_TYPE.yellowHollow:
      case STATUS_TYPE.yellowFilled:
        return 'yellow';
      case STATUS_TYPE.redHollow:
      case STATUS_TYPE.redFilled:
        return 'red';
      case STATUS_TYPE.grayFilled:
      case STATUS_TYPE.grayHollow:
      case STATUS_TYPE.paused:
        return 'gray';
      case STATUS_TYPE.blackHollow:
      case STATUS_TYPE.blackFilled:
      default:
        return 'black';
    }
  }, [status.type]);

  return (
    <Tooltip
      title={status.tooltip ? status.tooltip.title : undefined}
      content={status.tooltip ? status.tooltip.content : undefined}
      caption={status.tooltip ? status.tooltip.caption : undefined}
      position="top-start"
    >
      <div className={bindClasses('icon')} data-ppuc-id="ListSidebar.StatusIcon">
        <Icon name={iconName} color={iconColor} />
      </div>
    </Tooltip>
  );
};

export { StatusIcon };
